module.exports = __webpack_public_path__ + "static/media/jsl.7ecbfd7e.jpg";